import { useState } from 'react';
import { Image, Link } from 'Common';

export const HoverImageLink = ({ image, hoverImage = image, to, className, alt, href, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOverOut = () => setIsHovered((isHovered) => !isHovered);

  const displayImage = isHovered ? hoverImage : image;

  return (
    <Link to={to} href={href} {...props}>
      <Image className={className} src={displayImage} alt={alt} onMouseEnter={handleMouseOverOut} onMouseLeave={handleMouseOverOut} />
    </Link>
  );
};
